import React, { useState } from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import FieldCard from "./FieldCard";
import SelectObject from "../../ui/SelectObject";
import { postField } from "../../../services/httpClient";

interface FieldsState {
  fields: any;
  getFields: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const Fields = ({ fields, getFields, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: FieldsState) => {
  const [newLabel, setNewLabel] = useState<string>("");
  const [newType, setNewType] = useState<string>("");
  const [showAddField, setShowAddField] = useState(false);

  const fieldOptions = [
    { key: "checkbox", name: "Checkbox" },
    { key: "date", name: "Date" },
    { key: "text", name: "Text" },
    { key: "multi-line text", name: "Multi-Line Text" },
  ];

  const onClickAddField = () => {
    setShowAddField(true);
  };

  const updateNewLabel = (e: any) => {
    setNewLabel(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewType = (e: any) => {
    setNewType(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveField = (isDone: boolean = false) => {
    const newField = {
      label: newLabel,
      type: newType,
    };

    setErrMessage("");

    postField(newField)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Field Created");
        setToastBody(newLabel);
        setNewLabel("");
        setNewType("");
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setShowAddField(false);
        }
        getFields();
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });

    // trackFeatureEvent("button_click", "create_custom_field");
  };

  const onClickCancelAddField = () => {
    setErrMessage("");
    setShowAddField(false);
    setNewLabel("");
    setNewType("");
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  return (
    <>
      {fields.length === 0 ? (
        <p className="mt-2">No Field Records</p>
      ) : (
        <Row>
          <Col xs={12} lg={10} xl={8}>
            {fields?.map((item: any, index: number) => (
              <FieldCard
                key={item?.id}
                field={item}
                getFields={getFields}
                setOrgToSave={setOrgToSave}
                setErrMessage={setErrMessage}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
              />
            ))}
          </Col>
        </Row>
      )}
      {showAddField !== true && (
        <Row className="mt-3">
          <Col xs={4}>
            <Button className="app-tertiary-color button" onClick={(e) => onClickAddField()}>
              Add Field
            </Button>
          </Col>
        </Row>
      )}
      {showAddField === true && (
        <>
          <Row className="align-items-center my-3">
            <Col xs={4}>
              <Input label="Label" type="text" value={newLabel} onUpdate={(e: any) => updateNewLabel(e)} hasFocus={true} required={true} />
            </Col>
            <Col xs={4}>
              <SelectObject label="Type" value={newType} options={fieldOptions} onUpdate={(e: any) => updateNewType(e)} required={true} />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8}>
              <Stack direction="horizontal" gap={3}>
                <Button className="app-secondary-color button" onClick={() => onClickSaveField(false)}>
                  Save and Add Another
                </Button>
                <div className="vr" />
                <Button className="app-secondary-color button" onClick={() => onClickSaveField(true)}>
                  Save and Done
                </Button>
                <div className="vr" />
                <Button className="app-primary-color button" onClick={() => onClickCancelAddField()}>
                  Done
                </Button>
              </Stack>
            </Col>
          </Row>
        </>
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default Fields;
